import React, { useContext } from 'react';
import { Dropdown } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';

import { IconLanguage } from '@bynder/icons';
import { InfoContext } from '../../../context';
import { LanguageItem } from './LanguageItem';

export function LanguageMenu() {
	const { translate } = useTranslate();

	const { languages } = useContext(InfoContext);

	return (
		<Dropdown.Item
			submenu={
				<>
					{languages.available.map((language) => {
						return <LanguageItem language={language} key={language.locale} />;
					})}
				</>
			}
			icon={<IconLanguage />}
		>
			{translate('generalLanguage')}
		</Dropdown.Item>
	);
}
